import React from 'react';
import { Row, Col, Typography, Button, Image } from 'antd';
import { Link } from 'react-router-dom';
import ResearchFundImage from '../../Assets/Research-Fund-Introduction.png';
import '../../Styles/HomeStyles.css';

const { Title, Paragraph } = Typography;

const ResearchFundComponent = () => (
  <section className="home-research-fund-section">
    <div className="home-section-shell">
      <Row gutter={[64, 40]} justify="space-between" align="middle">
        <Col xs={24} md={10} lg={10} order={1}>
          <div className="home-research-fund-image-wrap">
            <Image
              preview={false}
              src={ResearchFundImage}
              alt="NCGSA Research Fund projects and space applications"
              className="home-research-fund-image"
            />
          </div>
        </Col>
        <Col xs={24} md={14} lg={14} order={2}>
          <p className="section-eyebrow home-research-fund-eyebrow">FUNDING DISCOVERY</p>
          <Title level={2} className="home-research-fund-title">Research Fund</Title>
          <div className="section-underline" aria-hidden="true" />
          <Paragraph className="home-research-fund-description">
            The NCGSA Research Fund supports innovative, market-oriented, and application-driven
            research in Geographic Information Science and space applications. Through collaborative
            academia-industry projects, the program advances modern geospatial technologies and
            space-based solutions that contribute to Pakistan’s sustainable socio-economic development.
          </Paragraph>
          <Button type="primary" size="large" className="home-research-fund-button">
            <Link to="/research-fund">Research Fund</Link>
          </Button>
        </Col>
      </Row>
    </div>
  </section>
);

export default ResearchFundComponent;
